import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';
import { routes } from 'routes/routes';
import { LoadRoute, PredictRoute, GroupedRoute, DetailedRoute } from './routes';
import { PredictionsEngineProvider } from './context/PredictionsEngineContext';

const SafeSwitch = Switch as unknown as React.ComponentType<any>;
const SafeRoute = Route as unknown as React.ComponentType<any>;

const PredictionsEnginePage: React.FC = () => {
  return (
    <PredictionsEngineProvider>
      <Container fluid className="py-4">
        <SafeSwitch>
          <SafeRoute path={`${routes.PREDICTIONS_ENGINE}/load`}>
            <LoadRoute />
          </SafeRoute>
          <SafeRoute path={`${routes.PREDICTIONS_ENGINE}/predict`}>
            <PredictRoute />
          </SafeRoute>
          <SafeRoute path={`${routes.PREDICTIONS_ENGINE}/grouped`}>
            <GroupedRoute />
          </SafeRoute>
          <SafeRoute path={`${routes.PREDICTIONS_ENGINE}/detailed`}>
            <DetailedRoute />
          </SafeRoute>
          <SafeRoute path={`${routes.PREDICTIONS_ENGINE}`} exact>
            <LoadRoute />
          </SafeRoute>
        </SafeSwitch>
      </Container>
    </PredictionsEngineProvider>
  );
};

export default PredictionsEnginePage;